import React from "react";

// import MarketIntelligenceFigure from "public/images/enerflo-residential-solar-market-intelligence.png";
import FinancingOperatingSystemFigure from "public/images/enerflo-solar-financing-operating-system-sfos-native-lending.png";

import HeroSection from "components/hero-section";

import {
  FeatureBlockContainer,
  FeatureBlockFigure,
  FeatureBlockHeader,
  ListBlock,
  // type FeatureBlockProps,
} from "./feature-block";

const ListItems = ({ items }: { items: string[] }) => {
  if (items.length > 6) {
    const middleIndex = Math.ceil(items.length / 2);
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <ListBlock items={items.slice(0, middleIndex)} />
        <ListBlock items={items.slice(middleIndex)} />
      </div>
    );
  }

  return <ListBlock items={items} />;
};

// const FeatureBlock = ({ title, heading, description, items, action, image }: FeatureBlockProps) => {
//   return (
//     <FeatureBlockContainer className="text-white">
//       <FeatureBlockFigure className="xs:w-3/5 md:w-4/5" {...image} />

//       <FeatureBlockHeader title={title} className="text-center max-w-lg mx-auto" titleClassName="text-amber-500">
//         {heading}
//       </FeatureBlockHeader>

//       <div className="space-y-6">
//         <p className="text-gray-100">{description}</p>
//         <ListItems items={items} />
//       </div>

//       <HeroSection.Action className="btn-white" href={action.href}>
//         {action.label}
//       </HeroSection.Action>
//     </FeatureBlockContainer>
//   );
// };

const blocks = [
  {
    title: "New! Solar Financial Operating System -- By Enerflo",
    heading: (
      <>
        <span>Your OS for Financing Residential Solar.</span>
        <br />
        <span className="text-primary">Zero Build.</span>
      </>
    ),
    description:
      "Built for solar financiers launching new programs or replacing outdated infrastructure, Enerflo gives banks, credit unions, capital providers, and solar lenders a modern way to operate. Originate deals, manage risk, and run operations across loans, leases, and PPAs in one system. Enerflo helps teams move faster, scale confidently, and keep their brand front and center.",
    items: ["Solar Loan", "Solar Lease", "Power Purchase Agreement (PPA)", "Prepaid PPA"],
    action: { href: "/features/solar-financing-operating-system", label: "Explore Resi Solar Financial OS" },
    image: { src: FinancingOperatingSystemFigure, alt: "Solar Financing Operating System (SFOS)" },
  },
  // TODO: Uncomment if/when this RSMI offering is available again
  // {
  //   title: "New! Residential Solar Market Intelligence -- By Enerflo",
  //   heading: (
  //     <>
  //       <span>Residential Solar Market Intelligence</span>
  //       <br />
  //       <span className="text-primary">for the Industry.</span>
  //     </>
  //   ),
  //   description:
  //     "Enerflo Solar Market Intelligence gives solar financiers, manufacturers, distributors, insurers, investment firms and more live installer performance data, regional demand signals, and portfolio benchmarking — sourced directly from active residential solar transaction data. Real-time data can provide insights and a through line between the larger quarterly, bi-annual and annual reporting the industry relies on.",
  //   items: [
  //     "Sourced from live installer transactions — not self-reported data",
  //     "Regional granularity that national reports can't provide",
  //     "Months ahead of public market data",
  //     "Structured for model ingestion and LLM integration",
  //   ],
  //   action: { href: "/features/residential-solar-market-intelligence", label: "Explore Resi Solar Market Intel" },
  //   image: { src: MarketIntelligenceFigure, alt: "Residential Solar Market Intelligence" },
  // },
];

const FinancingMarketIntel = () => {
  return (
    <div className="bg-navy-dark">
      <div className="bg-gradient-to-b from-navy via-navy to-primary/70">
        <HeroSection title={blocks[0].title}>
          {/* TODO: Uncomment if/when this RSMI offering is available again and remove tempoarary blocks renderer below */}
          {/* <HeroSection.Content className="grid grid-cols-1 md:grid-cols-2 gap-20">
            {blocks.map(block => (
              <FeatureBlock key={block.title} {...block} />
            ))}
          </HeroSection.Content> */}

          <HeroSection.Content>
            {blocks.map(block => (
              <FeatureBlockContainer
                key={block.title}
                className="text-white grid grid-cols-1 md:grid-cols-2 items-center gap-x-20 gap-y-8"
              >
                <div>
                  <FeatureBlockHeader title={block.title} titleClassName="text-amber-500">
                    {block.heading}
                  </FeatureBlockHeader>

                  <div className="space-y-6">
                    <p className="text-gray-100">{block.description}</p>
                    <ListItems items={block.items} />
                  </div>

                  <HeroSection.Action className="btn-white" href={block.action.href}>
                    {block.action.label}
                  </HeroSection.Action>
                </div>

                <FeatureBlockFigure className="xs:w-3/5 md:w-full lg:w-4/5" {...block.image} />
              </FeatureBlockContainer>
            ))}
          </HeroSection.Content>
        </HeroSection>
      </div>
    </div>
  );
};

export default FinancingMarketIntel;
